const Payment = () => {
    return (
        <div>
            <h2>Payment Report</h2>
        </div>
    )
}

export default Payment;